<template>
  <div class="operatorUser">
    <el-form :inline="true" :model="searchForm" class="demo-form-inline" label-width="90px">
      <el-form-item label="用户名" label-width="60px">
        <el-input style="width: 140px" @input="search" clearable v-model="searchForm.username"
                  placeholder="请输入"></el-input>
      </el-form-item>
      <!--      <el-form-item label="代理商">-->
      <!--        <DicInput :initName="searchForm.OperatorId" @fieldId="fieldId($event,'OperatorId')" :dicType="6"></DicInput>-->
      <!--      </el-form-item>-->
    </el-form>
    <div style="margin-bottom: 20px">
      <el-button @click="search">查询<i class="el-icon-search el-icon--right"></i></el-button>
      <el-button type="info" @click="clear">重置<i class="el-icon-refresh-right el-icon--right"></i></el-button>
      <el-button @click="goback">返回代理商管理</el-button>
      <el-button type="primary" style="float: right" @click="addUser">添加用户</el-button>
    </div>
    <div style="border: 1px solid #c9cdd6">
      <el-table
          :header-cell-style="{background:'#F5F5F5'}"
          :data="tableData"
          max-height="600"
          style="width: 100%"
      >
        <el-table-column
            prop="userName"
            label="用户名"
            align="center"
            width="120">
        </el-table-column>
        <el-table-column
            prop="roleNames"
            label="所属角色"
            align="center">
        </el-table-column>
        <el-table-column
            prop="name"
            align="center"
            label="姓名">
        </el-table-column>
        <el-table-column
            prop="gender"
            min-width="70"
            align="center"
            label="性别">
        </el-table-column>
        <el-table-column
            prop="workNumber"
            min-width="70"
            align="center"
            label="工号">
        </el-table-column>
        <el-table-column
            prop="email"
            min-width="95"
            align="center"
            label="Email">
        </el-table-column>
        <el-table-column
            prop="qq"
            min-width="80"
            align="center"
            label="QQ">
        </el-table-column>
        <el-table-column
            prop="phone"
            align="center"
            min-width="80"
            label="电话">
        </el-table-column>
        <el-table-column
            prop="note"
            min-width="140"
            align="center"
            label="备注">
        </el-table-column>
        <el-table-column
            prop="status"
            align="center"
            min-width="120"
            label="状态">
          <template slot-scope="scope">
            <el-switch
                v-model="scope.row.deleteFlag"
                @change="deleteFlag(scope.row)"
                :inactive-text="scope.row.deleteFlag?'禁用':'启用'">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column
            prop="upDateTime"
            align="center"
            min-width="120"
            label="上一次修改时间">
        </el-table-column>
        <el-table-column
            prop="address"
            fixed="right"
            min-width="150"
            align="center"
            label="操作">
          <template slot-scope="scope">
            <el-button @click="editorClick(scope.row)" type="text" size="small">编辑</el-button>
            <el-button @click="resetClick(scope.row)" type="text" size="small">重置密码</el-button>
            <el-button @click="loginClick(scope.row)" type="text" size="small">登录至代理商</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div style="margin-top: 20px">
      <Pagination :total='total' :currentPage='currPage' :pageSize='pageSize' @handleSizeChange='handleSizeChange'
                  @handleCurrentChange='handleCurrentChange'></Pagination>
    </div>
    <el-dialog
        :title="dialogTitle"
        :close-on-click-modal="false"
        :visible.sync="dialogVisible"
        width="670px">
      <el-form :model="userForm" :rules="rules" ref="userForm" label-width="100px" class="demo-ruleForm">
        <el-form-item style="width: 100%" label-width="0">
          <div>用户信息</div>
        </el-form-item>
        <el-form-item label="用户名" prop="userName">
          <el-input v-model="userForm.userName" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password" v-if="dialogTitle!=='修改代理商用户'">
          <el-input v-model="userForm.password" type="password" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="所属角色" v-if="dialogTitle==='修改代理商用户'">
          <el-input v-model="userForm.roleNames" @focus="test()" placeholder="请选择"></el-input>
        </el-form-item>
        <el-form-item style="width: 100%" label-width="0">
          <div>个人信息</div>
        </el-form-item>
        <el-form-item label="姓名" prop="name">
          <el-input v-model="userForm.name" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="性别" prop="gander">
          <el-radio-group v-model="userForm.gender">
            <el-radio label="1">男</el-radio>
            <el-radio label="2">女</el-radio>
            <el-radio label="3">保密</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="工号" prop="workNumber">
          <el-input v-model="userForm.workNumber" placeholder="请输入"></el-input>
        </el-form-item>
        <!--        <el-form-item label="用户类型">-->
        <!--          <el-radio-group v-model="userForm.userType">-->
        <!--            <el-radio label="2">医药药房</el-radio>-->
        <!--            <el-radio label="3">药店</el-radio>-->
        <!--          </el-radio-group>-->
        <!--        </el-form-item>-->
        <el-form-item label="Email">
          <el-input v-model="userForm.email" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="QQ">
          <el-input v-model="userForm.qq" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="电话">
          <el-input v-model="userForm.phone" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="备注" style="width: 600px">
          <el-input v-model="userForm.note" placeholder="请输入"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
     <el-button type="primary" @click="submitForm('userForm')">保存</el-button>
     <el-button @click="dialogVisible = false">关 闭</el-button>
  </span>
    </el-dialog>
    <el-dialog
        title="选择角色"
        :close-on-click-modal="false"
        :visible.sync="selectRoleVisible"
        width="500px">
      <div>
        <div class="flex align-center between mb-10">
          <div>
            角色名称
          </div>
          <div style="width: 150px">
            角色说明
          </div>
        </div>
        <el-tree
            :data="treeSelectlist"
            show-checkbox
            node-key="id"
            ref="userTree"
            @check-change="treeRole"
            default-expand-all
            :expand-on-click-node="false">
      <span class="custom-tree-node" slot-scope="{ node, data }">
        <span>{{ data.name }}</span>
        <span style="width: 142px">
        {{ data.note }}
        </span>
      </span>
        </el-tree>
      </div>
      <span slot="footer" class="dialog-footer">
     <el-button type="primary" @click="selectRoleOK()">确定</el-button>
     <el-button @click="selectRoleVisible = false">关 闭</el-button>
  </span>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination.vue';
import {cloneDeep} from "lodash";
import DicInput from "@/components/DicInput";

export default {
  name: "operatorUser",
  data() {
    return {
      treeSelectlist: [],
      tableData: [],
      srcList: [],
      doctor_count: '',
      searchForm: {
        name: "",
        userName: "",
        roleName: '',
      },
      userForm: {
        name: "",
        userName: "",
        password: '',
        workNumber: "",
        email: "",
        qq: "",
        phone: "",
        note: "",
        gender: '1',
        rolesStr: '',
        userType: '1'
      },
      rules: {
        userName: [
          {required: true, message: '请输入用户名', trigger: 'blur'},
        ],
        password: [
          {required: true, message: '请输入密码', trigger: 'blur'},
        ],
        name: [
          {required: true, message: '请输入姓名', trigger: 'blur'},
        ],
        gender: [
          {required: true, message: '请选择性别', trigger: 'change'}
        ],
        workNumber: [
          {required: true, message: '请输入工号', trigger: 'blur'},
        ],
      },
      initName: '',
      total: 0, //总条数
      currPage: 1,//当前页码
      pageSize: 10, //每页条数
      dialogVisible: false,
      selectRoleVisible: false,
      doctorDetails: '',
      dialogTitle: '添加代理商用户',
      userJson: '',
      defaultKeys: []
    }
  },
  components: {
    Pagination,
    DicInput
  },
  created() {
    this.userJson = window.utils.storage.getter('userJson')
  },
  methods: {
    goback() {
      this.$router.go(-1);
    },
    getFunctionTree(treeList) {
      let parentList = []
      let sonList = []
      treeList.forEach(item => {
        // if(item.name){
        //   item.lable = item.name;
        //   delete item.name
        // }
        if (item.parent === null) {
          item.children = []
          parentList.push(item)
        } else {
          item.children = []
          sonList.push(item)
        }
      })
      parentList.forEach(res => {
        this.getSonNote(res, sonList)
      })
      return parentList
    },
    getSonNote(a, sonList) {
      //debugger;
      sonList.forEach(item => {
        if (a.code === item.parent) {
          a.children.push(item)
        }
        if (a.children) {
          if (a.children.length > 0)
            a.children.forEach(item1 => {
              item1.children = []
              this.getSonNote(item1, sonList)
            })
        }
      })
    },
    deleteFlag(flag) {
      this.axios
          .delete("api/OperatorUser?id=" + flag.id, {params: {lockIt: flag.deleteFlag}}).then((res) => {
        this.$message({
          message: '操作成功',
          type: 'success'
        });
        this.init()
      })
    },
    loginClick(row) {
      this.axios
          .post("/api/Login/AutoLogin?id=" + row.id).then((res) => {
        try {
          let data = {
            ConfigType: 0
          }
          this.axios
              .get("/api/ParamConfig/GetOtherConfig", {params: data}).then((to) => {
               window.open(JSON.parse(to).top7 + '?token=' + res)
          })
        } catch {
          this.$message({
            type: 'info',
            message: '获取跳转地址失败'
          });
        }
      })
    },
    resetClick(row) {  // 重置密码
      this.$confirm('此操作将重置该用户密码, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.axios
            .post("api/OperatorUser/ReSetPassword?id=" + row.id,).then((res) => {
          this.$message({
            message: '重置成功',
            type: 'success'
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消重置'
          });
        });
      })
    },
    fieldId(item, name) { // 字典
      if (item.id) {
        this.searchForm[name] = item.id
      } else {
        this.searchForm[name] = ''
      }
    },
    addUser() {// 添加用户
      this.dialogTitle = '添加代理商用户'
      this.dialogVisible = true
      this.userForm = {
        name: "",
        userName: "",
        password: '',
        workNumber: "",
        email: "",
        qq: "",
        phone: "",
        note: "",
        gender: '1',
        rolesStr: '',
        userType: '1',
      }
      this.$refs['userForm'].resetFields();
    },
    editorClick(data) {
      this.roleList(data.operatorId)
      this.dialogTitle = '修改代理商用户'
      this.dialogVisible = true
      if (data.defaultPrivilege) {
        this.userForm.defaultPrivilege = JSON.parse(data.defaultPrivilege)
      }
      this.userForm = {
        id: data.id,
        name: data.name,
        userName: data.userName,
        password: data.password,
        workNumber: data.workNumber,
        email: data.email,
        qq: data.qq,
        phone: data.phone,
        note: data.note,
        rolesStr: data.roleIds,
        gender: String(data.gender),
        userType: String(data.userType),
        roleNames: data.roleNames,
        defaultPrivilege: data.privileges,
        operatorId: data.operatorId,
        pharmacyId: data.pharmacyId
      }
      this.$refs['userForm'].resetFields();
    },
    test() {
      this.selectRoleVisible = true
      if (this.userForm.rolesStr) {
        this.defaultKeys = JSON.parse(this.userForm.rolesStr)
        this.$nextTick(() => {
          this.$refs.userTree.setCheckedKeys(this.defaultKeys);
        })
      } else {
        this.$refs.userTree.setCheckedKeys([]);
      }
    },
    treeRole(node, data,) {
    },
    selectRoleOK() { // 获取权限列表
      let data = this.$refs.userTree.getCheckedNodes()
      let arrayName = []
      let array = []
      let defaultPrivilege = []
      for (let i in data) {
        arrayName += data[i].name + ','
        if (data[i].defaultPrivilege) {
          defaultPrivilege = [...JSON.parse(data[i].defaultPrivilege)]
        }
        array.push(data[i].id)
      }
      this.userForm.rolesStr = JSON.stringify(array)
      this.userForm.roleNames = arrayName
      this.userForm.defaultPrivilege = defaultPrivilege
      this.selectRoleVisible = false
    },
    // deleteClick() {
    //   this.$confirm('此操作将删除该用户, 是否继续?', '提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     type: 'warning'
    //   }).then(() => {
    //     this.$message({
    //       type: 'success',
    //       message: '删除成功!'
    //     });
    //   }).catch(() => {
    //     this.$message({
    //       type: 'info',
    //       message: '已取消删除'
    //     });
    //   });
    // },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let privileges
          if (typeof this.userForm.defaultPrivilege !== "string") {
            privileges = JSON.stringify(this.userForm.defaultPrivilege)
          } else {
            privileges = this.userForm.defaultPrivilege
          }
          if (this.dialogTitle === '修改代理商用户') {
            let data = {
              name: this.userForm.name,
              userName: this.userForm.userName,
              password: this.userForm.password,
              workNumber: this.userForm.workNumber,
              email: this.userForm.email,
              qq: this.userForm.qq,
              phone: this.userForm.phone,
              note: this.userForm.note,
              gender: Number(this.userForm.gender),
              userType: Number(this.userForm.userType),
              roleIds: this.userForm.rolesStr,
              roleNames: this.userForm.roleNames,
              privileges: privileges,
              operatorId: this.$route.query.operatorId,
            }
            this.axios
                .put("api/OperatorUser?id=" + this.userForm.id, data).then((res) => {
              this.$message({
                message: '添加成功',
                type: 'success'
              });
              this.dialogVisible = false
              this.init()
            })
          } else {
            let data = {
              name: this.userForm.name,
              userName: this.userForm.userName,
              password: this.userForm.password,
              workNumber: this.userForm.workNumber,
              email: this.userForm.email,
              qq: this.userForm.qq,
              phone: this.userForm.phone,
              note: this.userForm.note,
              gender: Number(this.userForm.gender),
              userType: Number(this.userForm.userType),
              roleIds: this.userForm.rolesStr,
              privileges: privileges,
              roleNames: this.userForm.roleNames,
              operatorId: this.$route.query.operatorId,
            }
            this.axios
                .post("api/OperatorUser/AddAdministrator", data).then((res) => {
              this.$message({
                message: '添加成功',
                type: 'success'
              });
              this.dialogVisible = false
              this.userForm = {
                name: '',
                userName: '',
                password: '',
                workNumber: '',
                email: '',
                qq: '',
                phone: '',
                note: '',
                gender: '',
                userType: '',
                rolesStr: '',
              }
              this.init()
            })
          }
        } else {
          return false;
        }
      });
    },
    // -------------------查询条件/清空-------------------
    search() {
      this.currPage = 1 //当前页码
      this.pageSize = 10 //每页条数
      this.init()
    },
    clear() {
      this.currPage = 1 //当前页码
      this.pageSize = 10 //每页条数
      this.searchForm = {
        username: '',
      }
      this.init()
    },
    // ----------分页控制-------------
    handleSizeChange(val) {
      this.pageSize = val
      this.init()
    },
    handleCurrentChange(val) {
      this.currPage = val
      this.init()
    },
    //获取角色列表
    roleList(id) {
      this.axios
          .get("api/Role/GetOperatorRoleTree?OperatorId=" + id).then((res) => {
        this.treeSelectlist = cloneDeep(res)
      })
    },
    // list
    init() {
      let data = {
        username: this.searchForm.username,
        OperatorId: this.$route.query.operatorId,
        page: this.currPage,
        pageSize: this.pageSize,
      }
      this.axios
          .get("api/OperatorUser", {params: data})
          .then((res) => {
            this.tableData = res.list
            this.total = res.count
          })
    }
  },
  mounted() {
    //
    this.init()
  }
}
</script>

<style lang="scss" scoped>
.operatorUser {
  text-align: start;
  min-height: 800px;

  & > div:nth-child(1) {
    margin-bottom: 20px;

    .el-button {
      box-shadow: 0 4px 8px #FFE0BA;
    }
  }

  .decBox {
    padding-right: 20px;

    i {
      font-style: normal;
    }
  }

  .el-form {
    display: flex;
    flex-wrap: wrap;
  }

  .doctorDetails {
    .titleName {
      font-weight: bold;
      padding-right: 10px;
    }

    .detailsLine {
      padding-bottom: 20px;
    }
  }
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}
</style>